import { TextContainerConfig } from '@Core/TextContainer/TextContainer.types';
import { IWinConfiguration } from '@Core/Win/WinPresentation.types';
import { IWintabConfigBase } from '@Core/Wintab/Wintab.types';
import { IBullshitCollectorConfig, IDynamicCasinoJackpotConfig, IGambleConfiguration } from '@GFTypes/GameStoreTypes';
import { IBeforeWinAnimationConfiguration } from '@GFTypes/GameStoreTypes/BeforeWinAnimationConfiguration';
import { IEnvironmentConfiguration } from '@GFTypes/GameStoreTypes/EnvironmentConfiguration';
import { IExpandingSymbolsConfiguration } from '@GFTypes/GameStoreTypes/ExpandingSymbolsConfiguration';
import { IInputConfig } from '@GFTypes/GameStoreTypes/InputConfig';
import { ILockAndRollAssetsConfig } from '@GFTypes/GameStoreTypes/LockAndRollAssetsConfig';
import { IMultiSymbolConfig } from '@GFTypes/GameStoreTypes/MultiSymbolConfig';
import { IPreloaderConfiguration } from '@GFTypes/GameStoreTypes/PreloaderConfiguration';
import { IAutoPlayState, ISpinParameters, ITurboModeState } from '@GFTypes/GameStoreTypes/SpinParameters';
import { ISymbolConfig } from '@GFTypes/GameStoreTypes/SymbolParameters';
import { IWildWheelConfiguration } from '@GFTypes/GameStoreTypes/WildWheelConfiguration';
import { IJackpotWin, IWinLevel } from '@GFTypes/GameStoreTypes/WinLevels';
import { IBonusBuyConfig } from '@GFTypes/Responses/AuthenticateResponse';
import { ISpecialGamesGameConfig } from '@GFTypes/SpecialGames';

export enum ESymbolsPaytableOrder {
    MULTIPLIER_DESCENDING = 'multiplierDescending'
}

export interface IGameConfig {
    gameTitle: string;
    dynamicCasinoJackpot: IDynamicCasinoJackpotConfig;
    bonusBuy: IBonusBuyConfig;
    defaultLanguage: string;
    availableLanguages: string[];
    helpContentKeysExcluded: string[];
    helpContentKeys: string[];
    autoPlaySettings: Pick<IAutoPlayState, 'delayBeforeSpin'>;
    winLevels: IWinLevel[];
    jackpotWins: IJackpotWin[];
    gamble: IGambleConfiguration;
    symbolsPaytableOrder: ESymbolsPaytableOrder | number[];
    symbols: ISymbolConfig[];
    spinningReels: number[][][];
    spinParametersSets: ISpinParameters[];
    winTab: IWintabConfigBase;
    wildWheel: IWildWheelConfiguration;
    preloader: IPreloaderConfiguration;
    beforeWinAnimation: IBeforeWinAnimationConfiguration;
    win: IWinConfiguration;
    environment: IEnvironmentConfiguration;
    allowedPayLines?: number[];
    payLines?: number[][];
    powerLines?: boolean;
    infoDisplay?: TextContainerConfig;
    turbo: Pick<ITurboModeState, 'animationsSpeedPerLevel' | 'winSpeedPerLevel' | 'deactivateTurboInFG'>;
    expandingSymbols?: IExpandingSymbolsConfiguration;
    specialGames: ISpecialGamesGameConfig;
    collectors?: IBullshitCollectorConfig[];
    staticJackpotLadderSymbol: number;
    multiSymbol: IMultiSymbolConfig;
    lockAndRollAssets: ILockAndRollAssetsConfig;
    input: IInputConfig;
}
